import { Badge, type BadgeProps } from '@mantine/core';
import type { MeetingViewModel } from '@actschurch/ccms-sdk';
import { computeMeetingState } from '../utils/meetingHelpers';
import { MEETING_STATE_COLORS, type MeetingState } from '../utils/meetingConstants';

interface MeetingStateBadgeProps extends Omit<BadgeProps, 'children'> {
  meeting?: MeetingViewModel | null;
  state?: MeetingState;
}

/** Derived lifecycle badge (Upcoming / In Progress / Completed / Cancelled). */
export function MeetingStateBadge({ meeting, state, variant = 'light', size = 'sm', ...rest }: MeetingStateBadgeProps) {
  const resolved: MeetingState = state ?? (meeting ? computeMeetingState(meeting) : 'Upcoming');
  return (
    <Badge
      variant={variant}
      size={size}
      color={MEETING_STATE_COLORS[resolved]}
      styles={{ label: { overflow: 'visible' } }}
      {...rest}
    >
      {resolved}
    </Badge>
  );
}
